import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { Loggerservice } from "../../../services/logger-service";

@Component({
  selector: "app-fare-family",
  templateUrl: "./fare-family.component.html"
})
export class FareFamilyComponent implements OnInit {
  actionmode: string = "Seacrh";
  headerDivName: string = "addOrEdit";
  showList: boolean = false;
  screentitle: string = "Fare Family";
  foredit: boolean = false;
  uid = "";
  roleID = "";
  fid = "";

  Prmary_Id;

  constructor(
    private vernostService: VernostServiceService,
    private logService: Loggerservice
  ) { }
  screen_details: any = [];
  search_details: any = [];
  previousData: any = [];
  parent_table = "fare_family_master";
  searchlist = false;
  loader = false;
  searchresult = false;
  serachtabledata: any = [];
  ngOnInit() {
    this.uid = localStorage.getItem("uid");
    this.roleID = localStorage.getItem("roleID");
    this.fid = localStorage.getItem("fid");
  }

  addForm() {
    document.getElementById("errs").innerHTML = "";
    this.actionmode = "Add";
    this.showList = false;
    this.screen_details = [];
    this.search_details = [];
  }

  searchForm(event) {
    this.actionmode = "Search";
    document.getElementById("errs").innerHTML = "";
    this.screen_details = [];
    this.search_details = [];
    this.searchresult = false;
  }

  submitData(event) {
    document.getElementById("errs").innerHTML = "";
    if (
      this.screen_details.from != undefined ||
      this.screen_details.to != undefined ||
      this.screen_details.eco != undefined ||
      this.screen_details.pre != undefined ||
      this.screen_details.flight != undefined

      // this.screen_details.flight != 0
    ) {
      var data = {
        from: this.screen_details.from,
        to: this.screen_details.to,
        eco: this.screen_details.eco,
        pre: this.screen_details.pre,
        flight: this.screen_details.flight,
        id: this.Prmary_Id
      };
      var screenInfo = [];
      screenInfo.push(data);

      if (this.foredit) {
        this.vernostService.updateFareFamily(data).subscribe(response => {
          if (response[0].mas == "success") {
            this.screen_details = [];

            document.getElementById("errs").innerHTML =
              "Record Updated Successfully";

            this.logService.create_log_masters(
              "'Component Name':Fare-Family Master,'Action':Update Record,'Modified by':" +
              localStorage.getItem("fname") +
              "'Privious Record':" +
              JSON.stringify(this.previousData) +
              ",'New Record':" +
              JSON.stringify(screenInfo),
              "info"
            );
          } else {
            document.getElementById("errs").innerHTML =
              "Failed To Update Record";
          }
        });
      } else {
        this.vernostService.submitFareFamily(data).subscribe(response => {
          if (response[0].mas == "success") {
            document.getElementById("errs").innerHTML =
              "Record Created Successfully";

            this.logService.create_log_masters(
              "'Component Name':Fare-Family Master,'Action':Create Record,'Modified by':" +
              localStorage.getItem("fname") +
              ",'Record':" +
              JSON.stringify(screenInfo),
              "info"
            );
            this.screen_details = [];
          } else {
            document.getElementById("errs").innerHTML =
              "Failed To Create Record";
          }
        });
      }
    } else {
      document.getElementById("errs").innerHTML = "Please Fill All Field";
    }
  }

  showFormData(data, flag) {
    if (flag == 2) {
      this.actionmode = "Edit";
      this.foredit = true;
      console.log(data);
      this.previousData.push(data);
      this.screen_details.from = data.tpm_from;
      this.screen_details.to = data.tpm_to;
      this.screen_details.eco = data.eco;
      this.screen_details.pre = data.pre;
      this.screen_details.flight = data.flight_type;
      this.Prmary_Id = data.fare_family_master_id;
    }
  }
  searchData() {
    this.searchlist = false;
    this.loader = true;

    var fieldOne = this.screen_details.from;
    var fieldTwo = this.screen_details.to;
    var fieldThree = this.screen_details.eco;
    var fieldFour = this.screen_details.pre;
    var fieldFive = this.screen_details.flight;

    if (
      (fieldOne == "" || fieldOne == undefined || fieldOne == "0") &&
      (fieldTwo == "" || fieldTwo == undefined) &&
      (fieldThree == "" || fieldThree == undefined) &&
      (fieldFour == "" || fieldFour == undefined) &&
      (fieldFive == "" || fieldFive == undefined)
    ) {
      this.loader = false;
      document.getElementById("errs").innerHTML =
        "Please apply filter to search";
      this.searchresult = false;
    } else {
      var searchitem = [];
      var searchColumn = [];
      if (fieldOne != "" && fieldOne != undefined) {
        searchitem.push(fieldOne);
        searchColumn.push("tpm_from");
      }
      if (fieldTwo != "" && fieldTwo != undefined) {
        searchitem.push(fieldTwo);
        searchColumn.push("tpm_to");
      }

      if (fieldThree != "" && fieldThree != undefined) {
        searchitem.push(fieldThree);
        searchColumn.push("eco");
      }

      if (fieldFour != "" && fieldFour != undefined) {
        searchitem.push(fieldFour);
        searchColumn.push("pre");
      }

      if (fieldFive != "" && fieldFive != undefined) {
        searchitem.push(fieldFive);
        searchColumn.push("flight_type");
      }
      console.log(this.parent_table);
      var dataFareFamily = {
        parent_table: this.parent_table,
        dbFields: searchColumn,
        searchData: searchitem,
        childtables: [],
        filters: []
      };
      this.vernostService.searchRecord(dataFareFamily).subscribe(recordResponse => {
        if (recordResponse.length > 0) {
          this.loader = false;
          document.getElementById("errs").innerHTML = "";
          this.serachtabledata = recordResponse;
          this.searchresult = true;

          this.logService.create_log_masters(
            "'Component Name':Fare-Family Master,'Action':Srarch Record,'Modified by':" +
            localStorage.getItem("fname"),
            "info"
          );
        } else {
          this.loader = false;
          document.getElementById("errs").innerHTML = "Record not found";
          this.serachtabledata = [];
          this.searchresult = false;
          setTimeout(function () {
            document.getElementById("errs").innerHTML = "";
          }, 5000);
        }
      });
    }
  }
}
